import FilterCard from './FilterCard'

export default Vue => {
  Vue.component(FilterCard.name, FilterCard)
}



// WEBPACK FOOTER //
// ./src/components/filtercard/index.js